export default class ContentSourceNonlinearContentSettingsService {
	constructor(apiService) {
		this.apiService = apiService
	}

	addEntity(params) {
		return this.apiService.callPost('me/content_source_nonlinear_content_settings', params)
	}

	updateEntity(id, params) {
		return this.apiService.callPost('me/content_source_nonlinear_content_settings/' + id, params)
	}

	deleteEntity(id, params) {
		return this.apiService.callDelete('me/content_source_nonlinear_content_settings/' + id, params)
	}
}



// WEBPACK FOOTER //
// ./src/service/ContentSourceNonlinearContentSettingsService.js